import useUserStore from '@monorepo/shared/src/graph/hooks/use-user';
import AssignmentGrid from './components/AssignmentGrid';
import { isTrialLicense } from '@monorepo/shared/src/graph/selectors/license-selector';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const Assignments: React.FC = () => {
  const navigate = useNavigate();
  const [{ me }] = useUserStore();
  const license = me?.licenses?.[0];
  const isTrialUser = isTrialLicense(license);

  useEffect(() => {
    if (isTrialUser) navigate('/home');
  }, [isTrialUser]);

  return <AssignmentGrid />;
};

export default Assignments;
